<template>
   <div class="team pt-4 bg-light-purple">
      <div class="landing-box text-white">
         <img loading="lazy" :src="landingBoxData.bannerImages[0].src" :alt="landingBoxData.bannerImages[0].alt" />
      </div>
      <div class="middle-box py-6 ">
         <div class="container container-1200">
            <div class="row">
               <div class="col-12 text-center header-text mb-5">
                  <h1>{{ teamPageData.founders.header }}</h1>
                  <p v-if="teamPageData.founders.shortDescription" class="mb-0">
                     {{ descriptionJoiner(teamPageData.founders.shortDescription) }}
                  </p>
               </div>
            </div>
            <div class="row founders-blocks">
               <div class="col-12 mb-8">
                  <div class="card-deck">
                     <div
                        v-for="(card, index) in founders"
                        :key="index"
                        class="card card-bordered"
                        itemscope
                        itemtype="http://schema.org/Person"
                     >
                        <div class="card-header text-center">
                           <img
                              :class="['img rounded-circle']"
                              :src="card.src"
                              :alt="card.name"
                              itemprop="image"
                           />
                        </div>
                        <div class="card-body">
                           <h3
                              class="text-center h4 bold mb-0"
                              itemprop="name"
                              v-text="card.name"
                           />
                           <div
                              class="text-center designation"
                              itemprop="jobTitle"
                              v-text="card.position"
                           />
                           <div class="mt-2" v-html="markedRender(card.description)" />
                        </div>
                        <div v-if="card.extra" class="card-footer">
                           <span>Follow {{ card.name }} on</span>
                           <span v-for="(social, indexB) in card.extra" :key="indexB">
                              <a title="" target="_blank" rel="noopener noreferrer" :href="social.link" itemprop="url">
                                 <i :class="social.icon" />
                              </a>
                           </span>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div class="row ">
               <div class="col-12 text-center header-text">
                  <h2>{{ teamPageData.team.header }}</h2>
                  <p v-if="teamPageData.team.shortDescription">
                     {{ descriptionJoiner(teamPageData.team.shortDescription) }}
                  </p>
               </div>
            </div>

            <TeamList :deptmembers="team" />
         </div>
      </div>
   </div>
</template>

<script>
import { mapState } from 'vuex';
import metaGenerator from '../util/meta.js';
import TeamList from '../components/team/TeamList';

export default {
   name: 'Team',
   metaInfo() {
      return metaGenerator(this.teamPageData);
   },
   components: {
      // Flipper,
      TeamList,
   },
   props: {
      isLarge: {
         type: Boolean,
         default: false,
      },
   },
   computed: {
      ...mapState(['teamPageData']),

      landingBoxData() {
         return this.teamPageData.landingBoxData;
      },
      founders() {
         return this.teamPageData.founders.cards;
      },
      team() {
         return this.teamPageData.team.departments;
      },
   },
   asyncData({ store }) {
      return Promise.all([store.dispatch('TEAM_PAGE_DATA_FETCH')]);
   },
};
</script>

<style lang="scss" scoped>
.team {
   width: 100%;
   .landing-box {
      max-height: 600px;
      overflow: hidden;
      img {
         width: 100%;
      }
   }

   .top-card-container {
      padding: 0 2.5rem;
      hr {
         border-color: rgba(62, 57, 107, 0.04);
      }
   }

   img {
      &.rounded-circle {
         max-width: 130px;
      }
   }

   .card {
      border: 1px solid rgba(62, 57, 107, 0.04);
      border-radius: 4px;
      background-color: rgba(255, 255, 255, 0.9);
      box-shadow: none;
      display: flex;
      flex-direction: column;
      .card-header {
         padding: 3.5rem 3.5rem 1.5rem;
      }

      .card-body {
         padding: 0 3.5rem;
      }

      .card-footer {
         padding: 0 3.5rem 3.5rem;
         color: #8786a4;
         span {
            display: inline-block;
            vertical-align: middle;
            margin: 0 5px;
            a {
               text-decoration: none;
               display: inline-flex;
               align-items: center;
               justify-content: center;
               color: #cecece;
               background: #fff;
               border-radius: 50%;
               width: 40px;
               height: 40px;
               box-shadow: 0 2px 4px 0 rgba(62, 57, 107, 0.13);
               &:hover {
                  color: #ccc;
                  opacity: 0.8;
                  box-shadow: 0 1px 2px 0 rgba(62, 57, 107, 0.13);
               }
            }
         }
      }

      .h4 {
         font-size: 19px;
      }
      .designation {
         font-size: 14px;
         line-height: 1.2;
         color: #434456;
      }
   }
}
</style>
